const productsPaginate = document.querySelector("a[data-paginate]");
if (productsPaginate) {
    productsPaginate.addEventListener("click", paginateProducts);
}

async function paginateProducts(event) {
    event.preventDefault();
    const trigger = event.target;
    trigger.blur();
    if (trigger.dataset.paginate === "") return;
    const url = trigger.dataset.paginate + "&section_id=" + trigger.dataset.section;
    const page = await fetchNextPage(url);
    if (!page || !page.products) return;

    const productList = document.querySelector("div[data-product-list]");
    page.products.forEach((product) => {
        productList.appendChild(product);
    });
    trigger.dataset.paginate = page.next ? page.next : "";
    if (!page.next) trigger.parentElement.parentElement.removeChild(trigger.parentElement);
}

async function fetchNextPage(url) {
    const promise = await fetch(url);
    if (!promise.ok) {
        console.error("Error on products pagination (fetching): ", promise.status, promise.statusText);
        return false;
    }
    const data = await promise.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const products = doc.querySelectorAll("div[data-product-card]");
    const paginate = doc.querySelector("a[data-paginate]");
    const page = {
        products: products && products.length ? products : false,
        next: paginate ? paginate.dataset.paginate : false,
    };
    return page;
}
